export class ConsoleMock {

    public static logSpy: jasmine.Spy;
    public static warnSpy: jasmine.Spy;
    public static errorSpy: jasmine.Spy;

    public static mockConsole() {
        ConsoleMock.logSpy = spyOn(console, 'log').and.callFake(() => { /* */ });
        ConsoleMock.warnSpy = spyOn(console, 'warn').and.callFake(() => { /* */ });
        ConsoleMock.errorSpy = spyOn(console, 'error').and.callFake(() => { /* */ });
    }
}
